import { httpTokenCommon } from "../helper/http-common";

class CustomerServices {
  getCustomerEnrollById(keyword: string) {
    return httpTokenCommon.get("customers/search", {
      params: {
        keyword,
        pageNumber: 1,
        pageSize: 10,
        sortDescending: false,
      },
    });
  }

  getCustomerById(id: string) {
    return httpTokenCommon.get(`customers/${id}`);
  }

  searchCustomers(keyword: string, pageSize = 20, silent = false) {
    return httpTokenCommon.get("customers/search", {
      params: {
        keyword: keyword.trim(),
        pageNumber: 1,
        pageSize,
        sortDescending: false,
      },
      silent,
    });
  }

  getAllCustomers(pageSize = 500) {
    return httpTokenCommon.get("customers/search", {
      params: {
        keyword: "",
        pageNumber: 1,
        pageSize,
        sortDescending: false,
      },
    });
  }

  getAllCustomersUnpaged() {
    return httpTokenCommon.get("customers");
  }

  getQuickAccessList() {
    return httpTokenCommon.get("customers/quickaccess");
  }
  ReSyncCustomer(id: string) {
    return httpTokenCommon.post(`customers/sync?customerId=${id}`, undefined, {
      silent: true,
    });
  }
  SyncCustomer(id: string) {
    return httpTokenCommon.get(`customers/syncstatus?customerId=${id}`);
  }

  /** Sets MustChangePassword on the portal user (existing Customers API). */
  resetCustomerPortalPassword(id: string) {
    return httpTokenCommon.post(
      `customers/ResetPassword?customerId=${id}`,
      undefined,
      { silent: true }
    );
  }
}

const customerServices = new CustomerServices();
export default customerServices;
